import React from 'react'

const HumanCulture = () => {
  return (
    <div>
      <h3>Working with words</h3>
      <p className='question'>A. Complete the given sentences with the suitable words from the box.</p>
      <p>a. The annual report has caused acute <strong>embarrassment</strong> to the government.</p>
      <p>b. Ellen has worn high-heels. She is <strong>teetering.</strong></p>
      <p>c. Look! The poor horse is <strong>dragging</strong> a heavy load.</p>
      <p>d. As they approached the <strong>outskirts</strong> of the city, Ella's mood visibly lightened.</p>
      <p>e. The parcel was <strong>wrapped</strong> in plain brown paper. It still looks attractive.</p>
      <p>f. Fruits and vegetables grow in <strong>abundance</strong> in the Terai region.</p>
      <p>g. They can abstract precious medicines from <strong>ordinary</strong> substances.</p>
      <hr/>
      <div>

        <p className='question'>C. Add suitable suffix to the root words given and write the parts of speech of each newely formed word.</p>
        <p>
neighbour + hood  =	neighbourhood -	Noun
<br/>
comfort + able = comfortable - Adjective
<br/>
shop + er = shopper - Noun
<br/>
husk + y = husky - Adjective
<br/>
squeamish + ness = squeamishness - Noun
<br/>
change + able = changeable - Adjective
<br/>
shine + ly = shinily - Adverb
<br/>
colloquial + ism = colloquialism - Noun 
<br/>
collect + ion = collection - Noun
<br/>
embarrass + ment = embarrassment - Noun
<br/>
persuade + ive = persuasive - Adjective
<br/>
type + ical = typical - Adjective
<br/>
differ + ence = difference - Noun
<br/>
ship + ment = shipment - Noun
<br/>
tropic + al = tropical - Adjective
<br/>
drive + er = driver - Noun
<br/>
reside + ence = residence - Noun
<br/>
brother + hood = brotherhood - Noun
<br/>
fresh + ness = freshness - Noun

        </p>
        
      </div>
      <hr/>
      <div>
        <p className='question'>D. Look for the following words related to waste management in an English dcitionary. Make sentences of your own using them.</p>
        <br/>
        <p>sewage = The factory was fined for releasing untreated sewage into the river.</p>
        <br/>
        <p>sludge = The workers removed the thick sludge from the bottom of the water treatment tank.</p>
        <br/>
        <p>organic waste = We separate organic waste from plastics and glass for composting at home.</p>
        <br/>
         <p>inorganic waste = Inorganic waste like broken glass and plastic bottles should be recycled properly.</p>
         <br/>
          <p> methane = Methane released from rotting food waste in landfills contributes to global warming.</p>
          <br/>
           <p>waste reduction = Waste reduction starts at home by avoiding single-use plastics and choosing reusable products.</p>
           <br/>
            <p>monofil = The fishermen preferred using a strong monofil fishing line because it was durable and nearly invisible underwater.</p>
            <br/>
             <p>market waste = The municipality has started a program to collect market waste separately for composting and recycling.</p>
             <br/>
              <p>incineration = Incineration helps reduce the amount of waste sent to landfills but must be managed carefully to control pollution.</p>
              <br/>
               <p>hazardous waste = Batteries and chemicals must be disposed of separately as they are considered hazardous waste.</p>
      </div>
      <div>
        <hr/>
        <h3>Comprehension</h3>
        <p className='question'>Answer the following questions.</p>
        <p className='question'>a. How does the author describe the Japanese waste management system?</p>
        <p>= The author describes the Japanese waste management system by explaining that three nights a week, residents in his neighborhood place their household trash in designated street corners. The trash is wrapped neatly in bundles, resembling gifts, and it disappears by dawn.</p>

        <p className='question'>b. What are the two reasons behind the existence of sodaigomi in Japanese culture?</p>
        <p>= The two reasons behind the existence of sodaigomi in Japanese culture are the small size of typical Japanese houses and the Japanese desire for freshness and purity.</p>

        <p className='question'>c. What, according to the author, do the Japanese feel at the thought of buying second hand items?</p>
        <p>= According to the author, the Japanese feel embarrassed at the thought of buying second-hand items.</p>

        <p className='question'>d. How is Malaysian culture different from Japanese culture concerning the used items?</p>
        <p>= In Malaysian culture, people rarely throw anything away. Even small, used items are kept and often sold, with customers enthusiastically bidding for second-hand goods. In contrast, Japanese culture is quite different,  people often throw out clean, new-looking items, and shoppers generally feel embarrassed at the idea of buying second-hand products.</p>

        <p className='question'>e. Why did the author feel awkward at the sodaigomi pile?</p>
        <p>= The author felt awkward at the sodaigomi pile because he couldn't believe that in Japanese culture, perfectly clean, whole, and usable items were simply thrown away.</p>
        
        <p className='question'>f. How many articles did the author bring to his house one after another?</p>
        <p>= The author brought several items to his house one after another. These included an ordinary low Japanese tea table, a shiny new bell for his son's bicycle, a small but attractive wooden cupboard, a complete set of wrenches and screwdrivers in a metal toolbox, a Naugahyde-covered barstool, and a lacquer serving tray.</p>

        <p className='question'>g. Why do most people try to find things in trash pile 'in the dead of the night'?</p>
        <p>= Most people try to find things in the trash pile 'in the dead of the night' so that others can pretend not to notice, allowing them to avoid embarrassment and bring no shame upon themselves or their community.</p>

        <p className='question'>h. How did the author's family assimilate Japanese culuter in using consumer goods?</p>
        <p>= The author's family assimilated Japanese culture in using consumer goods by quietly collecting useful items from the sodaigomi pile during the dead of night. This behavior mirrored the discreet way many Japanese people dealt with second-hand goods, allowing the family to adopt local customs while benefiting from the items others discarded.</p>
      </div>
      <div>
        <hr/>
        <h3>Critical thinking</h3>
        <p className='question'>a. If you happen to be in Japan someday, will you collect articles from sodaigomi? Why or why not?</p>
        <p>= Yes, I would collect articles from sodaigomi if I ever happen to be in Japan. In my country, people usually use things until they are old, damaged, or completely unusable before replacing them. So, living in a culture where perfectly clean and usable items are thrown away would feel quite different to me. At first, it might seem uncomfortable or unusual, but I believe it is practical and smart. Buying brand new goods from stores can be very expensive, and if I find good-quality items from sodaigomi, I could save a lot of money. It would also help me set up a home without spending too much. So, instead of buying overpriced new items, I would definitely collect useful items from sodaigomi and make the best use of them.</p>

        <p className='question'>b. There are some second hand shops in Nepal, too. But, people are not much interested in them. What practice would be suitable in managing second hand items in Nepal?</p>
        <p>= Some consumers in Nepal do enjoy buying and selling second-hand items due to their cost-effectiveness and their ethical and environmental benefits. However, the majority of people still hesitate to engage with second-hand markets. To encourage second-hand shopping in Nepal, the following practices could be adopted:
</p><p>
1. Brand Collaboration and Guidance: Second-hand shops should partner with popular and trusted brands. They can also guide consignors by informing them about which products and brands are in demand and most suitable for resale.
</p><p>
2. Fair and Transparent Pricing: Items should be priced realistically by starting with the original market value and reducing it based on wear, condition, and usage. This would help build trust among buyers and sellers.
</p><p>
3. Support Services for Sellers: Offering additional support like consignment consultations, pricing tips, quality photography, and assistance with shipping can make the process easier and more appealing to sellers, especially first-timers.
</p><p>
4. Active Social Media Engagement: Second-hand stores should maintain active and vibrant social media accounts to reach more people. Promoting available products, sharing customer success stories, and spreading awareness can help normalize and popularize the idea of second-hand shopping.
</p><p>
By making second-hand shopping more professional, accessible, and attractive, Nepal can develop a stronger culture around reusing and recycling, which benefits individuals, communities, and the environment.</p>
      </div>
      <div>
        <hr/>
        <h3>Writing</h3>
        <p className='question'>A. Write a paragraph elaborating the idea of 3Rs(reduce, reuse and recycle) in garbage management.</p>
        <p>= The idea of the 3Rs — reduce, reuse, and recycle — is very important in managing garbage and keeping our environment clean. Reduce means trying to create less waste in the first place. For example, we can reduce waste by using less plastic or buying only what we really need. Reuse means using things again instead of throwing them away. We can reuse old bottles, bags, or clothes instead of buying new ones. Recycle means turning old things into new products. When we recycle paper, plastic, and glass, they can be used to make something new and useful. If everyone follows the 3Rs, we can keep our surroundings cleaner, save natural resources, and help protect our Earth for future generations.</p>
<hr/>
        <p className='question'>B. Garbage management is a big problem in most of the cities in Nepal. Write a letter to the editor to be published in the daily newspaper suggesting the ways of 'Solving Garbage Problems.'</p>
        <p>To</p><p>
The Editor,</p><p>
The Rising Nepal,</p><p>
Kathmandu, Nepal.</p><p>

Subject: Suggesting Ways to Solve Garbage Problems in Cities</p><p>

Respected Sir/Madam,</p><p>

Through the column of your respected newspaper, I would like to draw the attention of the concerned authorities and the general public toward the growing problem of garbage management in many cities of Nepal.</p><p>

In cities like Kathmandu, Pokhara, and Biratnagar, garbage is seen piled up on roadsides, creating foul smells and posing serious health risks. The unmanaged waste blocks drainage systems, causes pollution, and makes the city look dirty and unhygienic.</p><p>

To solve this problem, the government should first improve waste collection systems by making them regular and timely. People should be encouraged to separate waste at the source into biodegradable and non-biodegradable materials. Public awareness campaigns must be launched to educate people about the importance of the 3Rs — reduce, reuse, and recycle. More dustbins should be placed in public areas, and fines should be charged for littering.
</p><p>
It is also important to involve local communities in managing waste at the local level. Schools and colleges can play a big role in teaching students about cleanliness and environmental care.
</p><p>
I hope this letter will bring attention to this urgent issue and inspire both authorities and citizens to work together for a cleaner and healthier Nepal.
</p><p>
Sincerely,</p><p>
Lily Thapa Magar</p><p>
Mustang, Nepal</p><p>
Date: July 2, 2025
</p>
      </div>
      <div>
        <hr/>
        <h3>Grammar</h3>
      <p className='question'>B. Use the words from the brackets to complete the sentences.</p>

<p>a. This house is very small. I want to buy a <strong>bigger</strong> one. (much / big)</p>

<p>b. I liked the magic show. It was <strong>far more exciting</strong> than I'd expected. (far / exciting)</p>

<p>c. It was very cold yesterday. It's <strong>a bit warmer</strong> today. (a bit / warm)</p>

<p>d. The warmer the weather, the <strong>better</strong> I feel. (good)</p>

<p>e. An average American earns <strong>considerably more</strong> than an average Nepali. (considerably / high)</p>

<p>f. Health care in Nepal is not as <strong>expensive</strong> as it is in the US. (expensive)</p>

<p>g. I think the problem is <strong>far more complicated</strong> than it seems. (far / complicated)</p>

<p>h. You are driving very fast. Would you please drive <strong>a bit more slowly</strong>? (a bit / slowly)</p>

<p>i. Your handwriting is not legible. Can you write <strong>a bit more neatly</strong>? (a bit / neat)</p>
<hr/>
      <p className='question'>C. Rewrite the following sentences with the sentence beginnings given below.</p>

<p>a. Kabir is less intelligent than he pretends. He is not as <strong>intelligent as he pretends.</strong></p>

<p>b. I am busy today but I was busier yesterday. I'm not <strong>as busy today as I was yesterday.</strong></p>

<p>c. Hari has lived in Kathmandu for 10 years but Bikram for 20 years. Bikram has <strong>lived in Kathmandu for more years than Hari has.</strong></p>

<p>d. I used to study 12 hours a day but nowadays I study only 5 hours a day. I don't <strong>study as much as I used to.</strong></p>

<p>e. It's a very good room in our hotel. In fact, it's the <strong>best room in our hotel.</strong></p>

<p>f. He earns 30 thousand rupees a month but spends 40 thousand. He spends <strong>more than he earns.</strong></p>

<p>g. There is no other mountain higher than Mt. Everest in the world. Mt. Everest is the <strong>highest mountain in the world.</strong></p>

<p>h. The place was nearer than I thought. It was not as <strong>far as I thought.</strong></p>

<p>i. Bharat can play better than Mohan. Mohan can't <strong>play as well as Bharat.</strong></p>
</div>
    </div>
  )
}

export default HumanCulture
